// components/InfoBoxes.jsx

export default function InfoBoxes({ setInfo }) {

  const handleClick = (e, data) => {
    // Only trigger if this mesh is the closest to camera
    if (e.intersections[0].object === e.object) {
      e.stopPropagation()  // prevent click passing to other hitboxes
      setInfo(data)
    }
  }

  return (
    <>
    <group
      onPointerEnter={ () => { document.body.style.cursor = 'pointer' } }
      onPointerLeave={ () => { document.body.style.cursor = 'default' } }>
        <group name="INFO">
          {/* Hitbox INFORMAATIO*/}
          <mesh
            position={[-1.8, 3.5, -5.5]}
            rotation={[0,0,0]}
            onClick={(e) => handleClick(e,{
              title: 'About this site',
              description: (
                <>
                This is my experimental portfolio website, where I reimagined ways to present visual work online. It is based on my Bachelor's thesis <em>Immersive Portfolio - Presenting Work in a Virtual Space</em> for the Visual Communication Design department at Aalto University. Built with Cinema 4D, Three.js library and React.

                </>
              ),
              url: 'https://roosaemiliaronkainen.com/welcome-to-my-home'
            })}
          >
            <boxGeometry args={[0.5, 0.6, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

          {/* Hitbox INFORMAATIO 2*/}
          <mesh
            position={[-2.3, 3.7, -5.5]}
            rotation={[0,0,0]}
            onClick={(e) => handleClick(e,{
              title: 'About me',
              description: "I’m Emilia, a visual communication designer and MA student at Aalto University. My work lives somewhere between storytelling and problem-solving, from visual identities to creative coding and publications to live visuals. I'm open to new projects - send me a message and let's talk!",
              url: 'https://roosaemiliaronkainen.com/about'
            })}
          >
            <boxGeometry args={[0.5, 0.6, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

        </group>

        <group name="TV">
          {/* Hitbox TV */}
          <mesh
            position={[-2,0.82,-4.72]}
            rotation={[0,0,0]}
            onClick={(e) => handleClick(e,{
              title: 'Rony Rex & F',
              description: (
                <>
                  3D character modelling and animation for <em>Rony Rex & F -Suljen Sun Suun</em> music video.
                </>
              ),
              url: 'https://roosaemiliaronkainen.com/rony-rex-f-suljen-sun-suun'
            })}
          >
            <boxGeometry args={[3, 1.7, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>
        </group>

        <group name="JULKAISUT">

          {/* Hitbox 1 HENKILÖKUVIA*/}
          <mesh
            position={[-1.1,-0.15,1.3]}
            rotation-x={Math.PI/2}
            onClick={(e) => handleClick(e,{
              title: 'Henkilökuvia',
              description: 'Narrative photo book project about a fly fisher Vesa.',
              url: 'https://roosaemiliaronkainen.com/henkil%C3%B6kuvia-1'
            })}
          >
            <boxGeometry args={[0.6, 0.6, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

          {/* Hitbox 2  TULI JA SAVU*/}
          <mesh
            position={[-0.35,-0.15,1.35]}
            rotation={[Math.PI/2, 0, Math.PI*0.8]}
            onClick={(e) => handleClick(e,{
              title: 'Tuli & Savu',
              description: (
                <>
                Graphic design for Tuli & Savu poetry magazine, edition 4/2023 Puhuja. The design won gold and silver awards at Vuoden Huiput 2024 together with Tuli & Savu editions Arkisto and Pyhä.
                </>
              ),
              url: 'https://roosaemiliaronkainen.com/tuli-savu'
            })}
          >
            <boxGeometry args={[0.6, 0.5, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

          {/* Hitbox 3  MANI-FESTO*/}
          <mesh
            position={[-0.6,-0.10,1.55]}
            rotation={[Math.PI/2, 0, Math.PI]}
            onClick={(e) => handleClick(e, {
            title: 'Mani-festo',
            description: 'Mani-festo is an adult stickerbook consisting of a 16-page publication and an attached sticker sheet. These seven illustrated spreads tell a story of feminism, power and joy of feminity. You can be the artist yourself and complete the scene!',
            url: 'https://roosaemiliaronkainen.com/mani-festo'
          })}
        >
            <boxGeometry args={[0.5, 0.4, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>
        </group>

        <group name="JULISTEET">
          {/* Hitbox GUILTY PLEASURES*/}
          <mesh
            position={[97.7, 0.42, 0.6]}
            rotation={[0,Math.PI/2,0]}
            onClick={(e) => handleClick(e,{
              title: 'Guilty Pleasures',
              description: 'Visual identity, logo and poster series for Guilty Pleasures club concept. The series is ongoing.',
              url: 'https://roosaemiliaronkainen.com/guilty-pleasures'
            })}
          >
            <boxGeometry args={[1.3, 1.7, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

          {/* Hitbox SLUTS AGAINST TECHNO*/}
          <mesh
            position={[98.25,1,-0.3]}
            rotation={[0,0,0]}
            onClick={(e) => handleClick(e,{
              title: 'Sluts Agains Techno',
              description: 'Poster design, 3D illustrations and animation for Sluts Against Techno club consept.',
              url: 'https://roosaemiliaronkainen.com/sluts-against-techno'
            })}
          >
            <boxGeometry args={[1, 2.2, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>

          {/* POSTBAR*/}
          <mesh
            position={[100, 0.5, -0.3]}
            rotation={[0,0,0]}
            onClick={(e) => handleClick(e,{
              title: 'Post Bar & Helsinki Pride Community',
              description: 'Poster design and illustration for the official afterparty of 2025 Helsinki Pride at Post Bar.',
              url: 'https://roosaemiliaronkainen.com/helsinki-pride-community-post-bar'
            })}
          >
            <boxGeometry args={[1.95, 1.6, 0.1]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>
        </group>

        <group name="INSTALLAATIO">
          {/* Hitbox TURKU MODERN*/}
          <mesh
            position={[149,10,3]}
            rotation={[0,Math.PI/2,0]}
            onClick={(e) => handleClick(e,{
              title: 'Turku Modern',
              description: 'Visuals and live performances for Turku Modern festival of 2023. A part of the project was an installation mapped and projected on the facade of the Art House Turku, a five storey high building at the centre of the festival.',
              url: 'https://roosaemiliaronkainen.com/turku-modern'
            })}
          >
            <boxGeometry args={[14, 14, 50]} />
            <meshBasicMaterial transparent opacity={0} />
          </mesh>
        </group>

        <group name="LAVA">
          {/* Hitbox LIVE VISUALS*/}
          <mesh
            position={[117.5, 2.2, 14.5]} 
            rotation={[0,Math.PI/2,0]}
            onClick={(e) => handleClick(e,{
              title: 'Alma',
              description: 'Stage visuals for Alma. Each track had on-beat back visuals, complementing the story and the energy of each song. Presented at some of the biggest music festivals in Finland, including Flow Festival, Ruisrock, Pori Jazz and Kesärauha.',
              url: 'https://roosaemiliaronkainen.com/alma-1'
            })}
          >
            <boxGeometry args={[6, 3, 1]} />
            <meshBasicMaterial  transparent opacity={0} />
          </mesh>
        </group>
    </group>
    </>
  )
}
